<template>
  <v-card
    class="base-card"
    tag="button"
    v-on="$listeners"
  >
    <div class="base-header">
      <slot name="top-left" />
      <slot name="top-right" />
    </div>
    <div class="base-info">
      <slot name="middle" />
    </div>
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'Card',
}
</script>

<style lang="scss" scoped>
.base-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  padding: 12px 20px;
  border-radius: 6px;
  border: 1px solid var(--v-grey-lighten-3);
  box-shadow: 0px 6px 8px -6px rgba(42, 51, 66, 0.06),
              0px 8px 16px -6px rgba(42, 51, 66, 0.04)!important;
  line-height: 24px;
}

.base-header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  font-weight: bold;
  font-size: 18px;
  border-bottom: 2px solid var(--v-grey-lighten-1);
}

.base-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: start;
  font-size: 14px;
  gap: 3px;

  ::v-deep {
    *:nth-child(even) {
    justify-self: end;
  }
  }
}
</style>
